import './_textual-banner.scss';

export default function TextualBanner() {
    document.querySelectorAll('.text-container').forEach(container => {
        const tables = container.querySelectorAll(':scope > table');

        tables.forEach(table => {
            if (table) {
                const wrapper = document.createElement('div');
                wrapper.classList.add('table-wrapper');

                table.parentNode?.insertBefore(wrapper, table);
                wrapper.appendChild(table);
            }
        });
    });
}
